import { RootState } from '@store/index'
import { ResortDetails } from '@models/resort'
import { OpinionProviders } from '@models/models'

export const selectResortDetails = (state: RootState): ResortDetails => state.resortState.resortDetails
export const selectAllOpinions = (state: RootState): OpinionProviders => state.resortState.opinions
export const selectSelectedRecommendedResortId = (state: RootState): number | null =>
  state.resortState.selectedRecommendedResortId
